// extracted by mini-css-extract-plugin
export default {"btn":"ButtonFollow_btn__sKPWy","disabled":"ButtonFollow_disabled__2PnTT","icon":"ButtonFollow_icon__NlrN7","reverse":"ButtonFollow_reverse__ZSfO7"};